import React from 'react'

import Navbar from "./Nav"
import Footer from "./Footer"
import ContactMe from  "./ContactMe"

export default function Layout({ children, contactCtaDisabled }) {
  return (
    <>
      <Navbar />
        { children }
        {!contactCtaDisabled && <ContactMe />}
      <Footer />
    </>
  )
}
